<div class="modal-bg" [ngStyle]="{'background': GlobalConstants.data.colors.coupon_modal_bg_color}">
    <svg class="absolute pointer modal-close-svg" (click)="handleClose()" width="15" height="15"
        viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
            fill="#919aa2" />
    </svg>
    <div class="modal-body coupon-error p-3">
        <div class="text-center">
            <svg class="mar-top-48" fill="red" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
            viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
            <g>
                <path
                    d="M503.839,395.379l-195.7-338.962C297.257,37.569,277.766,26.315,256,26.315c-21.765,0-41.257,11.254-52.139,30.102    L8.162,395.378c-10.883,18.85-10.883,41.356,0,60.205c10.883,18.849,30.373,30.102,52.139,30.102h391.398    c21.765,0,41.256-11.254,52.14-30.101C514.722,436.734,514.722,414.228,503.839,395.379z M477.861,440.586    c-5.461,9.458-15.241,15.104-26.162,15.104H60.301c-10.922,0-20.702-5.646-26.162-15.104c-5.46-9.458-5.46-20.75,0-30.208    L229.84,71.416c5.46-9.458,15.24-15.104,26.161-15.104c10.92,0,20.701,5.646,26.161,15.104l195.7,338.962    C483.321,419.836,483.321,431.128,477.861,440.586z" />
            </g>
            <g>
                <rect x="241.001" y="176.01" width="29.996" height="149.982" />
            </g>
            <g>
                <path
                    d="M256,355.99c-11.027,0-19.998,8.971-19.998,19.998s8.971,19.998,19.998,19.998c11.026,0,19.998-8.971,19.998-19.998    S267.027,355.99,256,355.99z" />
            </g>
        </svg>
        </div>
        <div class="fnt-16 ln-28 c333 error-line">
            We were unable to verify your card.
            <ul class="m-0 p-4">
                <li>
                    Please check the card details entered.
                </li>
                <li>
                    Please check if your domestic online usage is turned on.
                </li>
                <li>
                    Please use an eligible card.
                </li>
                <li>
                    The offer is already claimed using this card.
                </li>
            </ul>
        </div>
    </div>
</div>
